<div class="sidebar-container">
  <!-- Header: Oculto no Mobile/Tablet pois já existe o mobile-header no MainLayout -->
  @if (!isMobileOrTablet) {
  <div class="sidebar-header">
    <div class="brand">
      <div class="brand-icon">
        <i class="bi bi-truck" aria-hidden="true"></i>
      </div>
      <div class="brand-title-box">
        <h1 class="brand-title">Logística</h1>
        <p class="brand-description text-truncate">Gestão de Envios</p>
      </div>
    </div>
    <button
      class="sidebar-toggle"
      type="button"
      (click)="toggleSidebar()"
      title="Recolher/Expandir"
      aria-label="Recolher ou expandir menu lateral"
    >
      <i class="bi bi-chevron-left" aria-hidden="true"></i>
    </button>
  </div>
  }

  <!-- Navegação: renderizada dinamicamente por permissão -->
  <nav class="navigation" aria-label="Navegação principal">
    @if (!permissaoService.carregado()) {
    <div class="nav-section">
      <div class="nav-items">
        @for (i of [1, 2, 3]; track i) {
        <div class="nav-item nav-skeleton">
          <div class="nav-icon skeleton-box"></div>
          <span class="nav-label skeleton-box"></span>
        </div>
        }
      </div>
    </div>
    } @else {
    @for (section of menuSections(); track section.titulo) {
    <div class="nav-section">
      <h3 class="nav-section-title">{{ section.titulo }}</h3>
      <div class="nav-items">
        @for (item of section.items; track item.link) {
        <a [routerLink]="item.link" routerLinkActive="active" class="nav-item">
          <div class="nav-icon">
            <i class="bi {{ item.icon }}" aria-hidden="true"></i>
          </div>
          <span class="nav-label text-truncate" [title]="item.label">{{ item.label }}</span>
        </a>
        }
      </div>
    </div>
    }
    }
  </nav>

  <!-- Footer -->
  <div class="sidebar-footer">
    <div
      class="usuario-profile"
      role="button"
      tabindex="0"
      aria-label="Abrir perfil do usuário"
      (click)="toggleProfileModal()"
      (keydown)="onProfileKeydown($event)"
    >
      <div class="usuario-avatar profile">
        <i class="bi bi-person-circle" aria-hidden="true"></i>
      </div>
      <div class="usuario-info">
        <span class="usuario-name text-truncate">{{ nomeExibicaoPerfil() }}</span>
        <span class="usuario-role text-truncate">{{ descricaoExibicaoPerfil() }}</span>
      </div>
      <div class="usuario-actions">
        <button
          class="action-btn logout"
          type="button"
          (click)="onLogoutClick($event)"
          title="Sair"
          aria-label="Sair da conta"
        >
          <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
